var _linearGradient, _linearGradient2, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShieldCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c3ffe8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9973,
    stopColor: "#f0fff4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 105,
    y2: 407
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b59c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9cffac"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    fill: "url(#SVGID_1_)",
    r: 256
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 211.97c-24.577 0-44.574 19.998-44.574 44.574s19.997 44.574 44.574 44.574 44.574-19.997 44.574-44.574-19.997-44.574-44.574-44.574zm24.133 41.962-26.745 26.745c-1.741 1.741-4.022 2.612-6.303 2.612s-4.562-.87-6.303-2.612l-8.915-8.915c-3.482-3.482-3.482-9.124 0-12.606s9.124-3.482 12.606 0l2.612 2.612 20.441-20.441c3.482-3.482 9.124-3.482 12.606 0s3.483 9.123.001 12.605zm82.846-100.431c-49.345 0-100.484-45.741-100.998-46.202-3.395-3.064-8.567-3.064-11.962 0-.514.461-51.652 46.202-100.998 46.202-4.927 0-8.915 3.987-8.915 8.915v106.169c0 84.021 60.236 117.791 112.716 137.832 1.019.392 2.098.583 3.178.583s2.159-.191 3.178-.583c52.479-20.041 112.716-53.811 112.716-137.832v-106.169c-.001-4.928-3.988-8.915-8.915-8.915zm-106.979 165.447c-34.406 0-62.404-27.998-62.404-62.404s27.998-62.404 62.404-62.404 62.404 27.998 62.404 62.404-27.998 62.404-62.404 62.404z",
    fill: "url(#SVGID_2_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShieldCircle);
export default __webpack_public_path__ + "static/media/shield_circle.64651db8.svg";
export { ForwardRef as ReactComponent };